import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

export const Body = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 20px',
  // borderRadius: '10px',
  boxSizing: 'border-box',
  minWidth: '20vw',
}));

export const UserSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '12px',
}));

export const DetailSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'start',
  gap: '7px',
  width: '100%',
}));

export const NameSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '10px',
}));

export const CheckSection = styled(Box)(({ theme }) => ({
  flex: '0 1 10%',
  // display: "flex",
  // flexDirection: "column",
  // alignItems: "end",
}));

export const CommentBox = styled(Box)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  flex: '1 1 auto',
  maxWidth: 'fit-content',
}));

export const CommentSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'end',
  width: '100%',
}));

export const SeeSection = styled(Box)(({ theme }) => ({
  width: '9px',
  height: '9px',
  alignSelf: 'center',
  borderRadius: '50%',
  backgroundColor: '#36899f',
  flex: '1 0 auto',
}));

export const EmptySection = styled(Box)(({ theme }) => ({
  width: '9px',
  height: '9px',
  paddingright: '5px',
}));

export const NameText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  fontWeight: '500',
}));

export const CommentText = styled(NameText)(({ theme }) => ({
  fontWeight: 'initial',
  color: '#848484',
  fontSize: '14px',
  textOverflow: 'ellipsis',
  overflowX: 'hidden',
  width: '100%',
  maxWidth: '240px',
  flex: '1 1 10%',
}));

export const WhiteCommentText = styled(CommentText)(({ theme }) => ({
  fontWeight: 'bold',
  color: '#ffffff',
  fontSize: '14px',
  textOverflow: 'ellipsis',
}));

export const spanStyle = {
  width: '13px',
  height: '13px',
  borderRadius: '50%',
  backgroundColor: 'lightGreen',
  position: 'absolute',
  bottom: '2px',
  right: '-4px',
} as React.CSSProperties;
